"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var Types_1 = require("../../../api/Types");
var MappingModel_1 = require("../../mapping/MappingModel");
var Objects_1 = require("../../../api/Objects");
var ModelConstants_1 = require("../../../constants/ModelConstants");
var Field_1 = require("../../../constants/Field");
var DataItem_1 = require("./DataItem");
var DataType_1 = require("./DataType");
var ExceptionHandler_1 = require("./ExceptionHandler");
var TypeHelper_1 = require("./TypeHelper");
var Validator = /** @class */ (function () {
    function Validator() {
    }
    Validator.prototype.validate = function (sceModel, isInstance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!sceModel.model || sceModel.model === "") {
                            throw new Error(this.handleError("#.model cannot be undefined or empty"));
                        }
                        if (!sceModel.type || sceModel.type === "") {
                            throw new Error(this.handleError("#.type cannot be undefined or empty"));
                        }
                        if (!sceModel.properties || lodash_1.isEmpty(sceModel.properties)) {
                            throw new Error(this.handleError("#.properties cannot be undefined or empty"));
                        }
                        if (sceModel.objectId) {
                            if (!sceModel.version) {
                                throw new Error(this.handleError("#.version cannot be undefined if model has objectId"));
                            }
                        }
                        else if (sceModel.version) {
                            throw new Error(this.handleError("#.version must not be defined if model don't have objectId"));
                        }
                        return [4 /*yield*/, this.validateProperties(sceModel.properties, sceModel.objectId, isInstance ? isInstance : false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Validator.prototype.validateProperties = function (properties, objectId, isInstance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var saveOption, associatedObjectType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateSaveOption(properties.saveOption);
                        saveOption = properties.saveOption.value;
                        if (saveOption === "Draft") {
                            return [2 /*return*/];
                        }
                        if (!properties.category || lodash_1.isEmpty(properties.category)) {
                            throw new Error(this.handleError("#.properties.category cannot be undefined or empty"));
                        }
                        associatedObjectType = properties.associatedObjectType;
                        this.validateAssociatedObjectType(associatedObjectType);
                        if (!(objectId && !isInstance)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchMappings(associatedObjectType.typeId.value, associatedObjectType.version.value)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.validateModel(properties.model, objectId, properties.saveOption.value, isInstance)];
                    case 3:
                        _a.sent();
                        if (isInstance) {
                            this.validateObjectIds(properties.objectIds);
                        }
                        this.verifyFunctions(properties.functions);
                        !isInstance ? this.validateAlarms(properties.alarms) : this.validateAlarmsInstanceLevel(properties.alarms);
                        return [2 /*return*/];
                }
            });
        });
    };
    Validator.prototype.fetchMappings = function (typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objects, mappings, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.getMappingsByVersion(ModelConstants_1.ModelConstants.MappingModel, typeId, version)];
                    case 1:
                        mappings = _a.sent();
                        if (mappings.data.data.length === 0) {
                            throw new Error(this.handleError("Mappings not found for given Object type"));
                        }
                        this.mappingsModel = MappingModel_1.MappingModel.fromJson(mappings.data.data[0]);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw new Error(this.handleError("Validation Error: Failed to fetch mappings"));
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Validator.prototype.validateSaveOption = function (saveOption) {
        if (!saveOption || lodash_1.isEmpty(saveOption)) {
            throw new Error(this.handleError("#.properties.saveOption cannot be undefined or empty"));
        }
        if (!saveOption.value || saveOption.value === "") {
            throw new Error(this.handleError("#.properties.saveOption value cannot be undefined or empty"));
        }
        if (saveOption.value !== "Published" && saveOption.value !== "Draft") {
            throw new Error(this.handleError("#.properties.saveOption value should be either 'Published' or 'Draft'"));
        }
    };
    Validator.prototype.validateAssociatedObjectType = function (associatedObjectType) {
        if (!associatedObjectType || lodash_1.isEmpty(associatedObjectType)) {
            throw new Error(this.handleError("#.properties.associatedObjectType cannot be undefined or empty"));
        }
        if (!associatedObjectType.model ||
            lodash_1.isEmpty(associatedObjectType.model) ||
            associatedObjectType.model.value === "") {
            throw new Error(this.handleError("#.properties.associatedObjectType.model cannot be undefined or empty"));
        }
        if (!associatedObjectType.typeId ||
            lodash_1.isEmpty(associatedObjectType.typeId) ||
            associatedObjectType.typeId.value === "") {
            throw new Error(this.handleError("#.properties.associatedObjectType.typeId cannot be undefined or empty"));
        }
        if (!associatedObjectType.version ||
            lodash_1.isEmpty(associatedObjectType.version) ||
            associatedObjectType.version.value === "") {
            throw new Error(this.handleError("#.properties.associatedObjectType.version cannot be undefined or empty"));
        }
    };
    Validator.prototype.validateModel = function (model, objectId, saveOption, isInstance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var previousSaveOption;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!model || lodash_1.isEmpty(model)) {
                            throw new Error(this.handleError("#.properties.model cannot be undefined or empty"));
                        }
                        if (!model.name || lodash_1.isEmpty(model.name) || model.name.value === "") {
                            throw new Error(this.handleError("#.properties.model.name cannot be undefined or empty"));
                        }
                        if (!model.model || lodash_1.isEmpty(model.model) || model.model.value === "") {
                            throw new Error(this.handleError("#.properties.model.model cannot be undefined or empty"));
                        }
                        if (!model.typeId || lodash_1.isEmpty(model.typeId) || model.typeId.value === "") {
                            throw new Error(this.handleError("#.properties.model.typeId cannot be undefined or empty"));
                        }
                        if (!model.version ||
                            lodash_1.isEmpty(model.version) ||
                            model.version.value === "") {
                            // validate version as 1.0.0 // all numbers
                            throw new Error(this.handleError("#.properties.model.version cannot be undefined or empty"));
                        }
                        this.verifyVersionFormat(model.version.value);
                        if (isInstance) {
                            return [2 /*return*/];
                        }
                        if (!!objectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.verifyModelUniqueness(model.model.value, model.typeId.value, model.version.value)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        previousSaveOption = this.mappingsModel.properties.getSaveOption(objectId);
                        if (!(previousSaveOption &&
                            previousSaveOption === "Draft" &&
                            saveOption === "Published")) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.verifyModelUniqueness(model.model.value, model.typeId.value, model.version.value)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(previousSaveOption &&
                            previousSaveOption === "Published" &&
                            saveOption === "Published")) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.verifyModelUniqueness(model.model.value, model.typeId.value, model.version.value)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Validator.prototype.verifyVersionFormat = function (version) {
        var _this = this;
        var versionNumericValues = version.split(".");
        if (versionNumericValues.length !== 3) {
            throw new Error(this.handleError("Improper format of #.properties.model.version. Proper format is example 1.0.0"));
        }
        lodash_1.map(versionNumericValues, function (value) {
            var versionValue = parseInt(value, 10);
            if (isNaN(versionValue)) {
                throw new Error(_this.handleError("Improper format of #.properties.model.version. Proper format is example 1.0.0"));
            }
        });
    };
    Validator.prototype.verifyFunctions = function (functions) {
        var _this = this;
        lodash_1.map(Object.keys(functions), function (name) {
            var computeFunctionJson = functions[name];
            _this.verifyFunctionType(name, computeFunctionJson[Field_1.FIELD.FUNCTIONTYPE]);
            _this.verifyInputs(name, computeFunctionJson[Field_1.FIELD.INPUTS]);
            _this.verifyOutputs(name, computeFunctionJson[Field_1.FIELD.OUTPUTS]);
            _this.verifyTriggers(name, computeFunctionJson[Field_1.FIELD.TRIGGERS]);
            _this.verifyInhibit(name, computeFunctionJson[Field_1.FIELD.INHIBIT]);
        });
    };
    Validator.prototype.validateAlarms = function (alarms) {
        var _this = this;
        if (lodash_1.isEmpty(alarms)) {
            return;
        }
        lodash_1.map(Object.keys(alarms), function (functionName) {
            var alarmFunction = alarms[functionName];
            if (lodash_1.isEmpty(alarmFunction)) {
                throw new Error(_this.handleError("Alarm function " + functionName + " cannot be empty or undefined"));
            }
            lodash_1.map(Object.keys(alarmFunction), function (alarmName) {
                var alarm = alarmFunction[alarmName];
                if (lodash_1.isEmpty(alarm)) {
                    throw new Error(_this.handleError("Alarm " + alarmName + " cannot be empty or undefined"));
                }
                else if (!alarm[Field_1.FIELD.ALARMTYPE]) {
                    throw new Error(_this.handleError("Alarm " + alarmName + "/" + Field_1.FIELD.ALARMTYPE + " cannot be empty or undefined"));
                }
                var alarmType = alarm[Field_1.FIELD.ALARMTYPE];
                if (!alarmType[Field_1.FIELD.DATATYPE]) {
                    throw new Error(_this.handleError("Alarm " + alarmName + "/" + Field_1.FIELD.ALARMTYPE + " has dataType undefined"));
                }
                if (!alarmType[Field_1.FIELD.VALUE]) {
                    throw new Error(_this.handleError("Alarm " + alarmName + "/" + Field_1.FIELD.ALARMTYPE + " has value undefined"));
                }
            });
        });
    };
    Validator.prototype.validateAlarmsInstanceLevel = function (alarms) {
        var _this = this;
        if (lodash_1.isEmpty(alarms)) {
            return;
        }
        lodash_1.map(Object.keys(alarms), function (functionName) {
            var alarmFunction = alarms[functionName];
            if (lodash_1.isEmpty(alarmFunction)) {
                throw new Error(_this.handleError("Alarm function " + functionName + " cannot be empty or undefined"));
            }
            lodash_1.map(Object.keys(alarmFunction), function (alarmName) {
                var alarm = alarmFunction[alarmName];
                if (lodash_1.isEmpty(alarm)) {
                    throw new Error(_this.handleError("Alarm " + alarmName + " cannot be empty or undefined"));
                }
                else if (!alarm[Field_1.FIELD.ALARMTYPE]) {
                    throw new Error(_this.handleError("Alarm " + alarmName + "/" + Field_1.FIELD.ALARMTYPE + " cannot be empty or undefined"));
                }
            });
        });
    };
    Validator.prototype.verifyFunctionType = function (functionName, functionType) {
        if (!functionType) {
            throw new Error(this.handleError("functions." +
                functionName +
                ": 'functionType' cannot be empty or undefined"));
        }
        if (!functionType.dataType || !functionType.value) {
            throw new Error(this.handleError("functions." +
                functionName +
                ": dataType and value field of functionType cannot be empty or undefined"));
        }
    };
    Validator.prototype.verifyInputs = function (functionName, inputs) {
        var _this = this;
        if (!inputs || lodash_1.isEmpty(inputs)) {
            throw new Error(this.handleError("'inputs' cannot be undefined or empty"));
        }
        lodash_1.map(Object.keys(inputs), function (inputName) {
            if (inputName === Field_1.FIELD.CONDITIONS) {
                _this.verifyConditions(inputs[inputName]);
            }
            else if (inputName === Field_1.FIELD.ALARMMAPPING) {
                return;
            }
            else {
                var input = DataItem_1.DataItem.fromJson(inputName, inputs[inputName]);
                _this.validateDataType(functionName, inputName, input, "Input");
            }
        });
    };
    Validator.prototype.verifyOutputs = function (functionName, outputs) {
        var _this = this;
        if (!outputs) {
            return;
        }
        if (lodash_1.isEmpty(outputs)) {
            throw new Error(this.handleError("functions." + functionName + ": 'outputs' cannot be empty"));
        }
        lodash_1.map(Object.keys(outputs), function (outputName) {
            if (outputName === Field_1.FIELD.CONDITIONS) {
                return;
            }
            var output = DataItem_1.DataItem.fromJson(outputName, outputs[outputName]);
            _this.validateDataType(functionName, outputName, output, "Output");
        });
    };
    Validator.prototype.verifyTriggers = function (functionName, triggers) {
        var _this = this;
        if (!triggers) {
            return;
        }
        if (lodash_1.isEmpty(triggers)) {
            throw new Error(this.handleError("functions." + functionName + ": 'triggers' cannot be empty"));
        }
        var time = triggers[Field_1.FIELD.TIME];
        if (time) {
            if (!time.dataType) {
                throw new Error(this.handleError("functions." + functionName + ": Time trigger dataType is undefined"));
            }
            if (time.value === undefined) {
                throw new Error(this.handleError("functions." + functionName + ": Time trigger value is undefined"));
            }
        }
        var variableChange = triggers[Field_1.FIELD.VARIABLECHANGE];
        if (variableChange) {
            if (lodash_1.isEmpty(variableChange)) {
                throw new Error(this.handleError("functions." +
                    functionName +
                    ": variableChange trigger object is empty"));
            }
            lodash_1.map(Object.keys(variableChange), function (inputName) {
                var dataItem = DataItem_1.DataItem.fromJson(inputName, variableChange[inputName]);
                _this.validateDataType(functionName, inputName, dataItem, "Trigger");
                _this.validateValueLink(functionName, inputName, dataItem, "Trigger");
            });
        }
    };
    Validator.prototype.verifyInhibit = function (functionName, inhibit) {
        if (!inhibit) {
            return;
        }
        if (lodash_1.isEmpty(inhibit)) {
            throw new Error(this.handleError("functions." + functionName + ": 'inhibit' cannot be empty"));
        }
        var referenceValue = inhibit[Field_1.FIELD.REFERENCEVALUE];
        if (referenceValue) {
            var referenceValueDataItem = DataItem_1.DataItem.fromJson(Field_1.FIELD.REFERENCEVALUE, referenceValue);
            this.validateDataType(functionName, Field_1.FIELD.REFERENCEVALUE, referenceValueDataItem, "Inhibit");
            this.validateValueLink(functionName, Field_1.FIELD.REFERENCEVALUE, referenceValueDataItem, "Inhibit");
        }
        var actualValue = inhibit[Field_1.FIELD.ACTUALVALUE];
        if (actualValue) {
            var actualValueDataItem = DataItem_1.DataItem.fromJson(Field_1.FIELD.ACTUALVALUE, actualValue);
            this.validateDataType(functionName, Field_1.FIELD.ACTUALVALUE, actualValueDataItem, "Inhibit");
            this.validateValueLink(functionName, Field_1.FIELD.ACTUALVALUE, actualValueDataItem, "Inhibit");
        }
    };
    Validator.prototype.validateDataType = function (functionName, name, dataItem, variableType) {
        if (!dataItem.dataType) {
            throw new Error(this.handleError("functions." +
                functionName +
                ": 'dataType' of " +
                variableType +
                ":" +
                name +
                " is undefined"));
        }
        if (dataItem.dataType === DataType_1.DataType.array) {
            if (!dataItem.items) {
                throw new Error(this.handleError("functions." +
                    functionName +
                    ": No 'items' field defined for " +
                    variableType +
                    ":" +
                    name +
                    ". For 'array' dataType items field indicating type of array should be defined"));
            }
        }
    };
    Validator.prototype.validateValueLink = function (functionName, name, dataItem, variableType) {
        if (dataItem.link === undefined && dataItem.value === undefined) {
            throw new Error(this.handleError("functions." +
                functionName +
                ": 'value/link' of " +
                variableType +
                ":" +
                name +
                " is undefined"));
        }
    };
    Validator.prototype.verifyConditions = function (conditions) {
        // ToDo: Checking each condition/subcondition
        if (lodash_1.isEmpty(conditions)) {
            throw new Error(this.handleError("Conditions cannot be empty or undefined"));
        }
    };
    Validator.prototype.verifyModelUniqueness = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, functionVersions, typeVersions, latestVersion;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        types = new Types_1.Types();
                        return [4 /*yield*/, types
                                .getTypeVersions(ModelConstants_1.ModelConstants.FunctionTypeModel, typeId)
                                .catch(function (error) {
                                return undefined;
                            })];
                    case 1:
                        functionVersions = _a.sent();
                        if (functionVersions !== undefined) {
                            throw new Error("A function type with this type id is already available");
                        }
                        return [4 /*yield*/, types
                                .getTypeVersions(model, typeId)
                                .catch(function (error) {
                                return undefined;
                            })];
                    case 2:
                        typeVersions = _a.sent();
                        if (typeVersions === undefined) {
                            return [2 /*return*/];
                        }
                        latestVersion = typeVersions.data.versions[typeVersions.data.versions.length - 1];
                        if (!TypeHelper_1.TypeHelper.isHigherVersion(latestVersion, version)) {
                            throw new Error("Highest version available for this type is " + latestVersion + ". Use higher a version than " + latestVersion);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Validator.prototype.validateObjectIds = function (objectIds) {
        if (lodash_1.isEmpty(objectIds) || objectIds.value.length === 0) {
            throw new Error(this.handleError("Object Id's cannot be empty"));
        }
    };
    Validator.prototype.handleError = function (message) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return exceptionHandler.buildExceptionFromErrorMessage("Bad request", 400, "Validation error", message);
    };
    return Validator;
}());
exports.Validator = Validator;
//# sourceMappingURL=Validator.js.map